module.exports = __webpack_public_path__ + "static/media/item-border-selected-3.8066ab07.svg";